import { Autocomplete } from '@mui/material';
import type { AutocompleteProps } from '@mui/material/Autocomplete/Autocomplete';
import { UNLIMITED_DURATION } from '@weft/types';
import React from 'react';
import { VayuTextField } from '../../design/vayu-theme-components/VayuTextField';

const MONTHS = Array.from({ length: 12 }, (_, index) => index + 1);

type PlanDurationSelectProps = Omit<AutocompleteProps<number, false, false, false>, 'options' | 'renderInput'>;

export const PlanDurationSelect: React.FC<PlanDurationSelectProps> = (props) => {
  return (
    <Autocomplete
      fullWidth
      autoHighlight
      size="small"
      defaultValue={UNLIMITED_DURATION}
      getOptionLabel={getPlanDurationLabel}
      {...props}
      options={[UNLIMITED_DURATION, ...MONTHS]}
      renderInput={(params) => (
        <VayuTextField
          {...params}
          focused
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password',
          }}
        />
      )}
    />
  );
};

function getPlanDurationLabel(duration: number): string {
  if (duration === UNLIMITED_DURATION) {
    return 'Entire plan';
  }

  return `${duration} month${duration > 1 ? 's' : ''}`;
}